<template>
  <CRow>
    <CCol>
      <!-- Main card with action buttons -->
      <CCard>
        <CCardHeader>
          <strong>Quản lý linh kiện</strong>
          <div class="card-header-actions">
            <CButton
              color="info"
              shape="pill"
              @click="createBuyBom"
              class="mr-2">
              <CIcon name="cil-pencil" class="mr-1"/>
              Tạo danh mục
            </CButton>
            <CButton
              color="success"
              shape="pill"
              @click="openImportModal"
              class="mr-2">
              <CIcon name="cil-arrow-thick-to-bottom" class="mr-1"/>
              Nhập kho
            </CButton>
            <CButton
              color="warning"
              shape="pill"
              @click="openExportModal"
              class="mr-2">
              <CIcon name="cil-arrow-thick-to-top" class="mr-1"/>
              Xuất kho
            </CButton>
            <CButton
              v-if="isSuper"
              color="danger"
              shape="pill"
              @click="openTemplateModal">
              <CIcon name="cil-file" class="mr-1"/>
              Template
            </CButton>
          </div>
        </CCardHeader>
      </CCard>

      <!-- Select type of bill -->
      <CModal
        :show.sync="showBomTypeModal"
        color="info">
        <template #header>
          <h5 style="font-weight: bold; margin: 0;">Chọn loại danh mục</h5>
        </template>
        <div>
          <p class="text-muted mb-4">Vui lòng chọn loại danh mục bạn muốn tạo:</p>
          <CRow>
            <CCol md="6">
              <CButton
                color="success"                
                block                
                class="mb-3"
                @click="goToSearch('import')">
                <CIcon name="cil-arrow-thick-to-bottom" class="mr-2"/>
                Danh mục Nhập kho
              </CButton>
            </CCol>
            <CCol md="6">
              <CButton
                color="warning"                
                block                           
                @click="goToSearch('export')">
                <CIcon name="cil-arrow-thick-to-top" class="mr-2"/>
                Danh mục Xuất kho
              </CButton>
            </CCol>
          </CRow>
        </div>
        <template #footer>
          <CButton color="secondary" @click="showBomTypeModal = false">
            Hủy
          </CButton>
        </template>
      </CModal>

      <!-- Import modal -->
      <CModal
        :show.sync="showImportModal"
        @close="closeImportModal"
        color="success"
        size="lg">
        <template #header>
          <h5 style="font-weight: bold; margin: 0;">Nhập kho linh kiện từ tệp</h5>
        </template>
        <div>
          <p class="text-muted">
            Định dạng tệp excel phải gồm các cột: <strong>Nhóm linh kiện | EES CODE | Mô tả | Mã | NSX | Số lượng</strong>
          </p>
          <div class="text-center py-3">
            <label
              class="btn btn-outline-success"
              for="fileInputImport"
              style="cursor: pointer; border: 2px dashed #28a745; padding: 20px;"
            >
              <CIcon name="cil-folder-open" class="mr-2"/>
              <span v-if="!selectedFileImport">Click để chọn tệp</span>
              <span v-else><strong>{{ fileNameImport }}</strong></span>
            </label>
            <input
              type="file"
              accept=".xls,.xlsx"
              id="fileInputImport"
              style="display: none;"
              @change="onFileChangeImport">
          </div>
        </div>
        <template #footer>
          <CButton color="secondary" @click="closeImportModal">
            Hủy
          </CButton>
          <CButton
            color="success"
            @click="handleSubmitImport"
            :disabled="isUploadingImport || !selectedFileImport">
            <CSpinner v-if="isUploadingImport" size="sm" class="mr-2"/>
            {{ isUploadingImport ? "Đang tải..." : "Tải lên" }}
          </CButton>
        </template>
      </CModal>

      <!-- Export modal -->
      <CModal
        :show.sync="showExportModal"
        @close="closeExportModal"
        color="warning"
        size="lg">
        <template #header>
          <h5 style="font-weight: bold; margin: 0;">Xuất kho linh kiện từ tệp</h5>
        </template>
        <div>
          <p class="text-muted">
            Định dạng tệp excel phải gồm các cột: <strong>Nhóm linh kiện | EES CODE | Mô tả | Mã | NSX | Số lượng</strong>
          </p>
          <div class="text-center py-3">
            <label
              class="btn btn-outline-warning"
              for="fileInputExport"
              style="cursor: pointer; border: 2px dashed #ffc107; padding: 20px;"
            >
              <CIcon name="cil-folder-open" class="mr-2"/>
              <span v-if="!selectedFileExport">Click để chọn tệp</span>
              <span v-else><strong>{{ fileNameExport }}</strong></span>
            </label>
            <input
              type="file"
              accept=".xls,.xlsx"
              id="fileInputExport"
              style="display: none;"
              @change="onFileChangeExport">
          </div>
        </div>
        <template #footer>
          <CButton color="secondary" @click="closeExportModal">
            Hủy
          </CButton>
          <CButton
            color="warning"
            @click="handleSubmitExport"
            :disabled="isUploadingExport || !selectedFileExport">
            <CSpinner v-if="isUploadingExport" size="sm" class="mr-2"/>
            {{ isUploadingExport ? "Đang tải..." : "Tải lên" }}
          </CButton>
        </template>
      </CModal>

      <!-- Template modal -->
      <CModal
        v-if="isSuper"
        :show.sync="showTemplateModal"
        @close="closeTemplateModal"
        color="danger"
        size="lg">
        <template #header>
          <h5 style="font-weight: bold; margin: 0;">Tạo linh kiện từ tệp Template (chỉ dùng cho quản trị viên)</h5>
        </template>
        <div>
          <div class="alert alert-warning" role="alert">
            <strong>Chú ý:</strong> Định dạng tệp phải theo đúng quy định
          </div>
          <div class="text-center py-3">
            <label
              class="btn btn-outline-danger"
              for="fileInputTemplate"
              style="cursor: pointer; border: 2px dashed #dc3545; padding: 20px;"
            >
              <CIcon name="cil-folder-open" class="mr-2"/>
              <span v-if="!selectedFileTemplate">Click để chọn tệp</span>
              <span v-else><strong>{{ fileNameTemplate }}</strong></span>
            </label>
            <input
              type="file"
              accept=".xls,.xlsx"
              id="fileInputTemplate"
              style="display: none;"
              @change="onFileChangeTemplate">
          </div>
        </div>
        <template #footer>
          <CButton color="secondary" @click="closeTemplateModal">
            Hủy
          </CButton>
          <CButton
            color="danger"
            @click="handleSubmitTemplate"
            :disabled="isUploadingTemplate || !selectedFileTemplate">
            <CSpinner v-if="isUploadingTemplate" size="sm" class="mr-2"/>
            {{ isUploadingTemplate ? "Đang tải..." : "Tải lên" }}
          </CButton>
        </template>
      </CModal>

      <!-- Data preview card -->
      <CCard v-if="importedData.length > 0 || exportedData.length > 0">
        <CCardHeader>
          <strong>Dữ liệu tệp đã tải</strong>
          <div class="card-header-actions">
            <CButton
              :color="importedData.length > 0 ? 'success' : 'warning'"
              shape="pill"
              @click="confirmAction"
              :disabled="isConfirming">
              <CSpinner v-if="isConfirming" size="sm" class="mr-2"/>
              {{ isConfirming ? "Đang xử lý..." : (importedData.length > 0 ? "Xác nhận nhập" : "Xác nhận xuất") }}
            </CButton>
          </div>
        </CCardHeader>
        <CCardBody>
          <CDataTable
            :items="currentTableData"
            :fields="currentTableFields"
          />
        </CCardBody>
      </CCard>

      <!-- Location management card -->
      <CCard>
        <CCardHeader>
          <strong>Quản lý tên kho linh kiện</strong>
          <div class="card-header-actions">
            <CButton
              color="success"
              shape="pill"
              @click="addLocation"
              :disabled="!newLocationName">
              <CIcon name="cil-plus" class="mr-1"/>
              Thêm kho
            </CButton>
          </div>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol md="4">
              <CInput
                label="Tên kho:"
                placeholder="Nhập tên kho mới"
                v-model="newLocationName"
                horizontal
                :addLabelClasses="'text-right'"
              />
            </CCol>
            <CCol md="8">
              <CInput
                label="Địa chỉ:"
                placeholder="Nhập địa chỉ kho"
                v-model="newLocationAddress"
                horizontal
                :addLabelClasses="'text-right'"
              />
            </CCol>
          </CRow>

          <CRow v-if="locations.length > 0">
            <CCol>
              <strong>Danh sách kho:</strong>
              <CListGroup class="mt-1">
                <CListGroupItem
                  v-for="(location, index) in locations"
                  :key="index"
                  class="d-flex justify-content-between align-items-center py-2"
                >
                  <div v-if="editingIndex !== index" class="flex-grow-1">
                    <strong>{{ location.name }}</strong>
                    <div class="text-muted small" v-if="location.address">{{ location.address }}</div>
                  </div>
                  <div v-else class="flex-grow-1 mr-2">
                    <CRow>
                      <CCol md="6">
                        <CInput
                          placeholder="Tên kho"
                          v-model="editingLocationName"
                          class="mt-3"
                        />
                      </CCol>
                      <CCol md="6">
                        <CInput
                          placeholder="Địa chỉ"
                          v-model="editingLocationAddress"
                          class="mt-3"
                        />
                      </CCol>
                    </CRow>
                  </div>

                  <div class="d-flex align-items-center">
                    <CButton
                      v-if="editingIndex !== index"
                      color="info"
                      size="sm"
                      class="mr-1"
                      @click="startEditLocation(index, location)"
                    >
                      <CIcon name="cil-pencil"/>
                    </CButton>
                    <CButton
                      v-if="editingIndex === index"
                      color="success"
                      size="sm"
                      class="mr-1"
                      @click="saveEditLocation(index)"
                    >
                      <CIcon name="cil-check"/>
                    </CButton>
                    <CButton
                      v-if="editingIndex === index"
                      color="secondary"
                      size="sm"
                      class="mr-1"
                      @click="cancelEditLocation"
                    >
                      <CIcon name="cil-x"/>
                    </CButton>
                    <CButton
                      v-if="editingIndex !== index"
                      color="danger"
                      size="sm"
                      @click="deleteLocation(index, location)"
                    >
                      <CIcon name="cil-trash"/>
                    </CButton>
                  </div>
                </CListGroupItem>
              </CListGroup>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>


    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      // Modal states
      showImportModal: false,
      showExportModal: false,
      showTemplateModal: false,
      showBomTypeModal: false,
      // Import file
      fileNameImport: 'Duyệt tệp',
      selectedFileImport: null,
      isUploadingImport: false,
      // Export file
      fileNameExport: 'Duyệt tệp',
      selectedFileExport: null,
      isUploadingExport: false,
      // Template file
      fileNameTemplate: 'Duyệt tệp',
      selectedFileTemplate: null,
      isUploadingTemplate: false,
      isSuper: false,
      // Location management
      locations: [],
      newLocationName: '',
      newLocationAddress: '',
      editingIndex: -1,
      editingLocationName: '',
      editingLocationAddress: '',
      // Table data
      importedData: [],
      exportedData: [],
      isConfirming: false,
      importedFields: [],
      exportedFields: []
    };
  },
  computed: {
    currentTableData() {
      return this.importedData.length > 0 ? this.importedData : this.exportedData;
    },
    currentTableFields() {
      return this.importedData.length > 0 ? this.importedFields : this.exportedFields;
    }
  },
  created() {
    const role = localStorage.getItem('role')
    this.isSuper = ((role === 'root') || (role === 'super'))
    this.loadLocations()
  },
  methods: {
    // Translate header names from backend to Vietnamese
    translateHeaderNames(headers) {
      const translationMap = {
        'SL': 'Số lượng',
        'Location': 'Vị trí',
      };

      return headers.map(header => {
        if (typeof header === 'string') {
          return {
            key: header,
            label: translationMap[header] || header
          };
        } else if (header.key) {
          return {
            ...header,
            label: translationMap[header.key] || header.label || header.key
          };
        }
        return header;
      });
    },
    // Modal methods
    openImportModal() {
      this.fileNameImport = 'Duyệt tệp';
      this.selectedFileImport = null;
      this.showImportModal = true;
    },
    closeImportModal() {
      this.showImportModal = false;
      this.fileNameImport = 'Duyệt tệp';
      this.selectedFileImport = null;
      const fileInputImport = document.getElementById('fileInputImport');
      if (fileInputImport) {
        fileInputImport.value = '';
      }
    },
    openExportModal() {
      this.fileNameExport = 'Duyệt tệp';
      this.selectedFileExport = null;
      this.showExportModal = true;
    },
    closeExportModal() {
      this.showExportModal = false;
      this.fileNameExport = 'Duyệt tệp';
      this.selectedFileExport = null;
      const fileInputExport = document.getElementById('fileInputExport');
      if (fileInputExport) {
        fileInputExport.value = '';
      }
    },
    openTemplateModal() {
      this.fileNameTemplate = 'Duyệt tệp';
      this.selectedFileTemplate = null;
      this.showTemplateModal = true;
    },
    closeTemplateModal() {
      this.showTemplateModal = false;
      this.fileNameTemplate = 'Duyệt tệp';
      this.selectedFileTemplate = null;
      const fileInputTemplate = document.getElementById('fileInputTemplate');
      if (fileInputTemplate) {
        fileInputTemplate.value = '';
      }
    },
    // Import methods
    onFileChangeImport(event) {
      this.selectedFileImport = event.target.files[0];
      if (this.selectedFileImport) {
        this.fileNameImport = this.selectedFileImport.name;
      } else {
        this.fileNameImport = 'Duyệt tệp'
      }
    },
    handleSubmitImport() {
      if (!this.selectedFileImport) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.isUploadingImport = true;
      const formData = new FormData();
      formData.append("file", this.selectedFileImport);
      this.$request.post("/api/repo/importfromfilecheck", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        if (res.data.status === 'success') {
          // Replace with actual data from backend
          this.importedData = res.data.importdata?.data || [];
          this.importedFields = this.translateHeaderNames(res.data.importdata?.headers || []);
          this.exportedData = [];
          this.$swal.fire({
            icon: "success",
            title: "Tải và xử lý tệp nhập kho",
            text: "Tệp: " + this.fileNameImport + " đã tải và xử lý thành công!",
          });
          this.closeImportModal();
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Tải và xử lý tệp nhập kho",
            html: "Tệp: " + this.fileNameImport + " tải lên lỗi: " + res.data.status,
          });
        }
        this.isUploadingImport = false;
      }).catch((error) => {
        this.$swal.fire({
          icon: "error",
          title: "Tải và xử lý tệp nhập kho",
          html: "Tệp: " + this.fileNameImport + " tải lên lỗi: " + error,
        });
        this.isUploadingImport = false;
      });
    },
    // Export methods
    onFileChangeExport(event) {
      this.selectedFileExport = event.target.files[0];
      if (this.selectedFileExport) {
        this.fileNameExport = this.selectedFileExport.name;
      } else {
        this.fileNameExport = 'Duyệt tệp'
      }
    },
    handleSubmitExport() {
      if (!this.selectedFileExport) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.isUploadingExport = true;
      const formData = new FormData();
      formData.append("file", this.selectedFileExport);
      this.$request.post("/api/repo/exportfromfilecheck", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        if (res.data.status === 'success') {
          // Replace with actual data from backend
          this.exportedData = res.data.exportdata?.data || [];
          this.exportedFields = this.translateHeaderNames(res.data.exportdata?.headers || []);
          this.importedData = [];
          this.$swal.fire({
            icon: "success",
            title: "Tải và xử lý tệp xuất kho",
            text: "Tệp: " + this.fileNameExport + " đã tải và xử lý thành công!",
          });
          this.closeExportModal();
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Tải và xử lý tệp xuất kho",
            html: "Tệp: " + this.fileNameExport + " tải lên lỗi: " + res.data.status,
          });
        }
        this.isUploadingExport = false;
      })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Tải và xử lý tệp xuất kho",
            html: "Tệp: " + this.fileNameExport + " tải lên lỗi: " + error,
          });
          this.isUploadingExport = false;
        });
    },
    // Template methods
    onFileChangeTemplate(event) {
      this.selectedFileTemplate = event.target.files[0];
      if (this.selectedFileTemplate) {
        this.fileNameTemplate = this.selectedFileTemplate.name;
      } else {
        this.fileNameTemplate = 'Duyệt tệp'
      }
    },
    handleSubmitTemplate() {
      if (!this.selectedFileTemplate) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.$swal.fire({
        title: "Nhập thao tác",
        input: "text",
        inputPlaceholder: "Nhập thao tác...",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          if (result.value.toLowerCase() !== 'template') {
            this.$swal.fire({
              icon: "error",
              title: "Nhập thao tác",
              text: "Thao tác không hợp lệ!"
            });
          } else {
            this.isUploadingTemplate = true;
            const formData = new FormData();
            formData.append("file", this.selectedFileTemplate);
            this.$request.post("/api/repo/template", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
              .then((res) => {
                if (res.data.status === 'success') {
                  this.$swal.fire({
                    icon: "success",
                    title: "Tải lên tệp",
                    text: "Tệp: " + this.fileNameTemplate + " đã tải lên thành công!",
                  });
                  this.closeTemplateModal();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Tải lên tệp",
                    html: "Tệp: " + this.fileNameTemplate + " tải lên lỗi: " + res.data.status,
                  });
                }
                this.isUploadingTemplate = false;
              })
              .catch((error) => {
                this.$swal.fire({
                  icon: "error",
                  title: "Tải lên tệp",
                  html: "Tệp: " + this.fileNameTemplate + " tải lên lỗi: " + error,
                });
                this.isUploadingTemplate = false;
              });
          }
        }
      })
    },
    createBuyBom() {
      this.showBomTypeModal = true;
    },
    goToSearch(type) {
      this.showBomTypeModal = false;
      this.$router.push({
        path: '/component/search',
        query: {
          request: 'bill',
          type: type
        }
      });
    },
    loadLocations() {
      this.$request.get('/api/repo/locations').then(res => {
        if(res.data.locations) {
          this.locations = res.data.locations;
        }
      }).catch(error => {
        console.log('Load locations error:', error);
      })
    },
    addLocation() {
      if (!this.newLocationName.trim()) {
        return;
      }

      const locationInfo = `Tên kho: ${this.newLocationName}${this.newLocationAddress ? '<br>Địa chỉ: ' + this.newLocationAddress : ''}`;

      this.$swal.fire({
        title: "Thêm kho mới?",
        html: locationInfo,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Thêm",
        cancelButtonText: "Hủy"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post('/api/repo/locations', {
            name: this.newLocationName,
            address: this.newLocationAddress
          }).then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Thêm kho",
                text: "Thêm kho thành công"
              });
              this.newLocationName = '';
              this.newLocationAddress = '';
              this.loadLocations();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Thêm kho",
                text: "Thêm kho thất bại: " + res.data.status
              });
            }
          }).catch(error => {
            this.$swal.fire({
              icon: "error",
              title: "Thêm kho",
              text: "Lỗi: " + error.message
            });
          });
        }
      });
    },
    startEditLocation(index, location) {
      this.editingIndex = index;
      this.editingLocationName = location.name;
      this.editingLocationAddress = location.address || '';
    },
    cancelEditLocation() {
      this.editingIndex = -1;
      this.editingLocationName = '';
      this.editingLocationAddress = '';
    },
    saveEditLocation(index) {
      if (!this.editingLocationName.trim()) {
        return;
      }

      const oldLocation = this.locations[index];

      this.$swal.fire({
        title: "Cập nhật thông tin kho?",
        html: `Tên: <strong>${oldLocation.name}</strong> → <strong>${this.editingLocationName}</strong><br>Địa chỉ: ${oldLocation.address ||
        'Chưa có'} → ${this.editingLocationAddress || 'Chưa có'}`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Cập nhật",
        cancelButtonText: "Hủy"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.put('/api/repo/locations', {
            oldName: oldLocation.name,
            newName: this.editingLocationName,
            address: this.editingLocationAddress
          }).then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Cập nhật kho",
                text: "Cập nhật kho thành công"
              });
              this.cancelEditLocation();
              this.loadLocations();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Cập nhật kho",
                text: "Cập nhật kho thất bại: " + res.data.status
              });
            }
          }).catch(error => {
            this.$swal.fire({
              icon: "error",
              title: "Cập nhật kho",
              text: "Lỗi: " + error.message
            });
          });
        }
      });
    },
    deleteLocation(index, location) {
      this.$swal.fire({
        title: "Xóa kho?",
        text: `Bạn có chắc muốn xóa kho: ${location.name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy",
        confirmButtonColor: "#d33"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.delete('/api/repo/locations', {
            data: { name: location.name }
          }).then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Xóa kho",
                text: "Xóa kho thành công"
              });
              this.loadLocations();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa kho",
                text: "Xóa kho thất bại: " + res.data.status
              });
            }
          }).catch(error => {
            this.$swal.fire({
              icon: "error",
              title: "Xóa kho",
              text: "Lỗi: " + error.message
            });
          });
        }
      });
    },
    confirmAction() {
      if (this.importedData.length > 0) {
        // Confirm import with password
        this.$swal.fire({
          title: "Xác nhận nhập kho",
          input: "text",
          inputPlaceholder: "Nhập mật khẩu xác nhận...",
          showCancelButton: true,
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy"
        }).then((result) => {
          if (result.isConfirmed && result.value) {
            if(result.value.toLowerCase() !== 'nhap kho') {
              this.$swal.fire({
                icon: "error",
                title: "Xác nhận nhập kho",
                text: "Mật khẩu không hợp lệ!"
              });
              return;
            }
            this.isConfirming = true;
            this.$request.post("/api/repo/confirmimport", {
              data: this.importedData
            }).then((res) => {
              if (res.data.status === 'success') {
                this.$swal.fire({
                  icon: "success",
                  title: "Nhập kho thành công",
                  text: "Đã nhập " + this.importedData.length + " dòng dữ liệu"
                });
                this.importedData = [];
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Nhập kho thất bại",
                  text: res.data.status
                });
              }
              this.isConfirming = false;
            }).catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Nhập kho thất bại",
                html: "Lỗi: " + error
              });
              this.isConfirming = false;
            });
          }
        });
      } else if (this.exportedData.length > 0) {
        // Confirm export with password
        this.$swal.fire({
          title: "Xác nhận xuất kho",
          input: "text",
          inputPlaceholder: "Nhập mật khẩu xác nhận...",
          showCancelButton: true,
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy"
        }).then((result) => {
          if (result.isConfirmed && result.value) {
            if(result.value.toLowerCase() !== 'xuat kho') {
              this.$swal.fire({
                icon: "error",
                title: "Xác nhận xuất kho",
                text: "Mật khẩu không hợp lệ!"
              });
              return;
            }
            this.isConfirming = true;
            this.$request.post("/api/repo/confirmexport", {
              data: this.exportedData
            }).then((res) => {
              if (res.data.status === 'success') {
                this.$swal.fire({
                  icon: "success",
                  title: "Xuất kho thành công",
                  text: "Đã xuất " + this.exportedData.length + " dòng dữ liệu"
                });
                this.exportedData = [];
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Xuất kho thất bại",
                  text: res.data.status
                });
              }
              this.isConfirming = false;
            }).catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Xuất kho thất bại",
                html: "Lỗi: " + error
              });
              this.isConfirming = false;
            });
          }
        });
      }
    }
  },
};
</script>
